// Actions
const PRINT = 'ghg/print/PRINT';

const initialState = {};

export default function reducer (state = initialState, action) {
    switch (action.type) {
        case PRINT:
            return {
                ...state,
            };

        default:
            return state;
    }
}

export function print () {
    return {
        type: PRINT,
    }
}



/** WEBPACK FOOTER **
 ** ./src/redux/modules/print.js
 **/